// extracted by mini-css-extract-plugin
export default {"icon":"NewPostSelectOption-module__icon--c_B6h"};